import { parseServerInstant } from '../../Dashboard/core/mskTime'
import { PoolFillPoint } from './types'

const nf = new Intl.NumberFormat('ru-RU')
const slotFmt = new Intl.DateTimeFormat('ru-RU', {
  timeZone: 'Europe/Moscow',
  day: '2-digit',
  month: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
})
const timeFmt = new Intl.DateTimeFormat('ru-RU', {
  timeZone: 'Europe/Moscow',
  hour: '2-digit',
  minute: '2-digit',
})

const sign = (currency: string) => (currency === 'RUB' ? '₽' : currency)
const amount = (v: number, currency: string) => `${nf.format(Math.round(v))} ${sign(currency)}`
const row = (label: string, value: string, nested = false) =>
  `<div class="d-flex justify-content-between gap-4${
    nested ? ' ps-3 text-muted' : ''
  }"><span>${label}</span><span class="fw-semibold">${value}</span></div>`

// Тултип слота: сколько взято выплат, сколько покрыто депозитами (и сколько из
// этого держат диспуты), сколько осталось покрыть. Время — по МСК.
export function buildPoolFillTooltipHtml(p: PoolFillPoint, currency: string): string {
  const title = slotFmt.format(parseServerInstant(p.ts)).replace(',', '')
  if (p.pct === null) {
    return `<div class="p-3 fs-7"><div class="fw-bold">${title}</div><div class="text-muted">В эти 15 минут нет решений мэтчинга</div></div>`
  }
  const lines = [
    `<div class="fw-bold mb-2">${title} · занято ${Math.round(p.pct)} %</div>`,
    row('Взято выплат', `${amount(p.capacity, currency)} (${p.payouts})`),
    row('Покрыто депозитами', amount(p.used, currency)),
  ]
  if (p.held_count > 0) {
    const parts = [`${p.held_count} деп.`]
    if (p.next_release) {
      parts.push(`ближайшее освобождение ${timeFmt.format(parseServerInstant(p.next_release))}`)
    }
    if (p.held_open_ended > 0) parts.push(`без срока — ${p.held_open_ended}`)
    lines.push(row('из них держат диспуты', `${amount(p.held, currency)} (${parts.join(', ')})`, true))
  }
  lines.push(row('Осталось покрыть', amount(p.free, currency)))
  return `<div class="p-3 fs-7">${lines.join('')}</div>`
}
